"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadsSummaryUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var components_1 = require("../../../components/");
var utils_1 = require("../../../utils");
var copy_1 = require("../copy");
var utils_2 = require("../utils");
var MeterReadsSummaryUI_styled_1 = require("./MeterReadsSummaryUI.styled");
var components_2 = require("./components");
var MeterReadsSummaryUI = function (_a) {
    var _b;
    var elecMeterReads = _a.elecMeterReads, gasMeterReads = _a.gasMeterReads, supplies = _a.supplies, latestBillingEndDate = _a.latestBillingEndDate;
    var _c = (0, core_1.useComponents)(), SummaryCard = _c.SummaryCard, Row = _c.Row, Col = _c.Col;
    var gas = (0, utils_1.getSupplyMeterInfo)(supplies, 'gas');
    var electricity = (0, utils_1.getSupplyMeterInfo)(supplies, 'electricity');
    var elecMeterType = !electricity || !electricity.isActive || !electricity.rawMeterType
        ? undefined
        : electricity.isSmart
            ? 'smart'
            : 'traditional';
    var gasMeterType = !gas || !gas.isActive || !gas.rawMeterType
        ? undefined
        : gas.isSmart
            ? 'smart'
            : 'traditional';
    var elecInfo = (0, utils_2.getMeterInfo)(elecMeterReads, elecMeterType, latestBillingEndDate);
    var gasInfo = (0, utils_2.getMeterInfo)(gasMeterReads, gasMeterType, latestBillingEndDate);
    var priorityInfo = (0, utils_2.getInfo)(elecInfo, gasInfo);
    var smartNonCommRecentManual = priorityInfo.reason === 'recentManual';
    var smartMeterOk = priorityInfo.meterType === 'smart' &&
        priorityInfo.status === 'ok' &&
        !smartNonCommRecentManual;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.METER_READS_INFO, properties: (_b = {
                status: priorityInfo.status,
                reason: priorityInfo.reason,
                elecMeterType: elecMeterType,
                gasMeterType: gasMeterType
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b) }, priorityInfo.status !== 'error' ? (react_1.default.createElement(SummaryCard, { "data-testid": "meter-reads-info", heading: react_1.default.createElement(Copy, { copyKey: "meterReadsHeading" }), icon: "meterReads", footer: !smartMeterOk ? react_1.default.createElement(components_2.Footer, null) : undefined },
        react_1.default.createElement(components_1.StyledInfoContent, null,
            react_1.default.createElement(Row, { isNested: true },
                react_1.default.createElement(Col, { span: 8 },
                    react_1.default.createElement(components_2.Content, { meterInfo: priorityInfo }),
                    smartMeterOk && react_1.default.createElement(Copy, { copyKey: "smartMeterOkMessage" })),
                react_1.default.createElement(Col, { span: 4 },
                    react_1.default.createElement(MeterReadsSummaryUI_styled_1.StyledImage, null,
                        react_1.default.createElement(components_2.Image, { meterInfo: priorityInfo }))))))) : (react_1.default.createElement(components_1.NoDataError, { heading: react_1.default.createElement(Copy, { copyKey: "meterReadsHeading" }), "data-testid": 'meter-reads-info-error' }))));
};
exports.MeterReadsSummaryUI = MeterReadsSummaryUI;
